export default (state = {}, action) => {
  switch (action.type) {
    case 'GET_PLACE':
      return { ...state, place: action.place };
    case 'GET_PLACES':
      return { ...state, places: action.places };
    default:
      return state;
  }
};
